module.exports = __webpack_public_path__ + "static/media/sofiya_rukadikar.fb70069a.png";